export default {"src":"/_next/static/media/logo-9.fb72797b.svg","height":52,"width":51,"blurWidth":0,"blurHeight":0};